// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.space_Di4uV {
  margin-bottom: 40px;
}

.content_ZvrTj {
  max-width: 50vw;
}

.usersCount_SMiOW {
  font-weight: 700;
  color: var(--color-base600) !important;
  padding-bottom: 12px;
}

@media ( max-width: 767px ) {
  .content_ZvrTj {
    max-width: fit-content;
  }
}`, "",{"version":3,"sources":["webpack://./../../packages/recovr-plugins/lib/alerts/editor/LocationAlertsEditor.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,sCAAsC;EACtC,oBAAoB;AACtB;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF","sourcesContent":[".space {\n  margin-bottom: 40px;\n}\n\n.content {\n  max-width: 50vw;\n}\n\n.usersCount {\n  font-weight: 700;\n  color: var(--color-base600) !important;\n  padding-bottom: 12px;\n}\n\n@media ( max-width: 767px ) {\n  .content {\n    max-width: fit-content;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"space": `space_Di4uV`,
	"content": `content_ZvrTj`,
	"usersCount": `usersCount_SMiOW`
};
export default ___CSS_LOADER_EXPORT___;
